<script setup lang="ts">
const {meta} = useAppConfig();
useHead({
  title: `${meta.title}-政策扶持`,
})

const projectModalOpenStore = reactive({
  notFound: false,
  result: false
})

// 这个其实是 agent
const companyModalOpenStore = reactive({
  notFound: false,
  result: false
})
const keyword = ref<string>('');
</script>

<template>
  <section class="pagePolicy">
    <policy-block1
        v-model="keyword"
        @open-project-result-modal="projectModalOpenStore.result = true"
        @open-project-not-found-modal="projectModalOpenStore.notFound = true"
        @open-company-result-modal="companyModalOpenStore.result = true"
        @open-company-not-found-modal="companyModalOpenStore.notFound=true"
    />
    <policy-block2/>
    <policy-block3/>

    <project-not-found-modal :open="projectModalOpenStore.notFound"
                             @on-close="projectModalOpenStore.notFound = false"/>
    <company-not-found-modal :open="companyModalOpenStore.notFound"
                             @on-close="companyModalOpenStore.notFound = false"/>

    <project-result-modal :open="projectModalOpenStore.result"
                          @on-close="projectModalOpenStore.result = false"
                          :name="keyword"
    />
    <company-result-modal :open="companyModalOpenStore.result"
                          @on-close="companyModalOpenStore.result = false"
                          :name="keyword"
    />
  </section>
</template>

<style scoped lang="scss">
.pagePolicy {
  background-color: #ECE6E6;
  padding-bottom: 106px;
}
</style>